module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_6000.00197eab.png";